export enum TabControlTemplate
{
    default,
    style2
}